import { sendToApi } from 'api/client'

export interface PlagiarismDetectionResult {
  index: number
  url: string
  title: string
  textsnippet: string
  htmlsnippet: string
  minwordsmatched: string
  viewurl: string
}

export interface PlagiarismDetectionResponse {
  querywords: string
  cost: string
  count: number
  result?: PlagiarismDetectionResult[]
  allviewurl: string
}

export const createPlagiarismDetectionRequest = (text: string) => {
  return sendToApi<PlagiarismDetectionResponse>(`/detect_plagiarism`, {
    method: 'POST',
    body: {
      text,
    },
  })
}
